const e = {
  solid: "solid",
  dashed: "dashed"
}, r = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
}, a = {
  transparent: "transparent",
  white: "#ffffff",
  black: "#000000",
  surface: {
    1: {
      light: "#ffffff",
      dark: "#18191b"
    },
    2: {
      light: "#f9f9f8",
      dark: "#111110"
    }
  },
  alpha: {
    white: {
      1: "rgba(255, 255, 255, 0.05)",
      2: "rgba(255, 255, 255, 0.1)",
      3: "rgba(255, 255, 255, 0.15)",
      4: "rgba(255, 255, 255, 0.2)",
      5: "rgba(255, 255, 255, 0.3)",
      6: "rgba(255, 255, 255, 0.4)",
      7: "rgba(255, 255, 255, 0.5)",
      8: "rgba(255, 255, 255, 0.6)",
      9: "rgba(255, 255, 255, 0.7)",
      10: "rgba(255, 255, 255, 0.8)",
      11: "rgba(255, 255, 255, 0.9)",
      12: "rgba(255, 255, 255, 0.95)"
    },
    black: {
      1: "rgba(0, 0, 0, 0.05)",
      2: "rgba(0, 0, 0, 0.1)",
      3: "rgba(0, 0, 0, 0.15)",
      4: "rgba(0, 0, 0, 0.2)",
      5: "rgba(0, 0, 0, 0.3)",
      6: "rgba(0, 0, 0, 0.4)",
      7: "rgba(0, 0, 0, 0.5)",
      8: "rgba(0, 0, 0, 0.6)",
      9: "rgba(0, 0, 0, 0.7)",
      10: "rgba(0, 0, 0, 0.8)",
      11: "rgba(0, 0, 0, 0.9)",
      12: "rgba(0, 0, 0, 0.95)"
    }
  },
  gray: {
    1: { light: "#fcfcfd", dark: "#111113" },
    2: { light: "#f9f9fb", dark: "#18191b" },
    3: { light: "#f0f0f3", dark: "#212225" },
    4: { light: "#e8e8ec", dark: "#272a2d" },
    5: { light: "#e0e1e6", dark: "#2e3135" },
    6: { light: "#d9d9e0", dark: "#363a3f" },
    7: { light: "#cdced6", dark: "#43484e" },
    8: { light: "#b9bbc6", dark: "#5a6169" },
    9: { light: "#8b8d98", dark: "#696e77" },
    10: { light: "#80838d", dark: "#777b84" },
    11: { light: "#60646c", dark: "#b0b4ba" },
    12: { light: "#1c2024", dark: "#edeef0" }
  },
  beige: {
    1: { light: "#fdfdfc", dark: "#111110" },
    2: { light: "#f9f9f8", dark: "#191918" },
    3: { light: "#f1f0ef", dark: "#222221" },
    4: { light: "#e9e8e6", dark: "#2a2a28" },
    5: { light: "#e2e1de", dark: "#31312e" },
    6: { light: "#dad9d6", dark: "#3b3a37" },
    7: { light: "#cfceca", dark: "#494844" },
    8: { light: "#bcbbb5", dark: "#62605b" },
    9: { light: "#8d8d86", dark: "#6f6d66" },
    10: { light: "#82827c", dark: "#7c7b74" },
    11: { light: "#63635e", dark: "#b5b3ad" },
    12: { light: "#21201c", dark: "#eeeeec" }
  },
  accent: {
    1: { light: "#fffcfc", dark: "#181111" },
    2: { light: "#fff8f7", dark: "#1f1513" },
    3: { light: "#feebe7", dark: "#391714" },
    4: { light: "#ffdcd3", dark: "#4e1511" },
    5: { light: "#ffcdc2", dark: "#5e1c16" },
    6: { light: "#fdbdaf", dark: "#6e2920" },
    7: { light: "#f5a898", dark: "#853a2d" },
    8: { light: "#ec8e7b", dark: "#ac4d39" },
    9: { light: "#e54d2e", dark: "#e54d2e" },
    10: { light: "#dd4425", dark: "#ec6142" },
    11: { light: "#d13415", dark: "#ff977d" },
    12: { light: "#5c271f", dark: "#fbd3cb" }
  },
  green: {
    1: { light: "#fbfefd", dark: "#0d1512" },
    2: { light: "#f4fbf7", dark: "#121c18" },
    3: { light: "#e6f7ed", dark: "#0f2e22" },
    4: { light: "#d6f1e3", dark: "#0b3b2c" },
    5: { light: "#c3e9d7", dark: "#114837" },
    6: { light: "#acdec8", dark: "#1b5745" },
    7: { light: "#8bceb6", dark: "#246854" },
    8: { light: "#56ba9f", dark: "#2a7e68" },
    9: { light: "#29a383", dark: "#29a383" },
    10: { light: "#26997b", dark: "#27b08b" },
    11: { light: "#208368", dark: "#1fd8a4" },
    12: { light: "#1d3b31", dark: "#adf0d4" }
  },
  yellow: {
    1: { light: "#FEFDFB", dark: "#16120C" },
    2: { light: "#FEFBE9", dark: "#1D180F" },
    3: { light: "#FFF7C2", dark: "#302008" },
    4: { light: "#FFEE9C", dark: "#3F2700" },
    5: { light: "#FBE577", dark: "#4D3000" },
    6: { light: "#F3D673", dark: "#5C3D05" },
    7: { light: "#E9C162", dark: "#714F19" },
    8: { light: "#F3D673", dark: "#8F6424" },
    9: { light: "#FFC53D", dark: "#FFC53D" },
    10: { light: "#FFBA18", dark: "#FFD60A" },
    11: { light: "#AB6400", dark: "#FFCA16" },
    12: { light: "#4F3422", dark: "#FFE7B3" }
  },
  blue: {
    1: { light: "#fdfdfe", dark: "#11131f" },
    2: { light: "#f7f9ff", dark: "#141726" },
    3: { light: "#edf2fe", dark: "#182449" },
    4: { light: "#e1e9ff", dark: "#1d2e62" },
    5: { light: "#d2deff", dark: "#253974" },
    6: { light: "#c1d0ff", dark: "#304384" },
    7: { light: "#abbdf9", dark: "#3a4f97" },
    8: { light: "#8da4ef", dark: "#435db1" },
    9: { light: "#3e63dd", dark: "#3e63dd" },
    10: { light: "#3358d4", dark: "#5472e4" },
    11: { light: "#3a5bc7", dark: "#9eb1ff" },
    12: { light: "#1f2d5c", dark: "#d6e1ff" }
  },
  red: {
    1: { light: "#fffcfd", dark: "#191113" },
    2: { light: "#fff7f8", dark: "#1e1517" },
    3: { light: "#feeaed", dark: "#3a141e" },
    4: { light: "#ffdce1", dark: "#4e1325" },
    5: { light: "#ffced6", dark: "#5e1a2e" },
    6: { light: "#f8bfc8", dark: "#6f2539" },
    7: { light: "#efacb8", dark: "#883447" },
    8: { light: "#e592a3", dark: "#b3445a" },
    9: { light: "#e54666", dark: "#e54666" },
    10: { light: "#dc3b5d", dark: "#ec5a72" },
    11: { light: "#ca244d", dark: "#ff949d" },
    12: { light: "#64172b", dark: "#fed2e1" }
  },
  purple: {
    1: { light: "#fdfcfe", dark: "#14121f" },
    2: { light: "#faf8ff", dark: "#1b1525" },
    3: { light: "#f4f0fe", dark: "#291f43" },
    4: { light: "#ebe4ff", dark: "#33255b" },
    5: { light: "#e1d9ff", dark: "#3c2e69" },
    6: { light: "#d4cafe", dark: "#473876" },
    7: { light: "#c2b5f5", dark: "#56468b" },
    8: { light: "#aa99ec", dark: "#6958ad" },
    9: { light: "#654dc4", dark: "#6e56cf" },
    10: { light: "#654dc4", dark: "#7d66d9" },
    11: { light: "#6550b9", dark: "#baa7ff" },
    12: { light: "#2f265f", dark: "#e2ddfe" }
  }
}, d = {
  sans: "Inter, -apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif",
  mono: "Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace"
}, t = {
  0: "1rem",
  1: "1rem",
  2: "1.25rem",
  3: "1.5rem",
  4: "1.75rem",
  5: "1.75rem",
  6: "2rem",
  7: "2.25rem",
  8: "2.5rem",
  9: "3.5rem",
  "code-0": "1.0rem",
  "code-1": "1.0rem",
  "code-2": "1.25rem",
  "code-3": "1.5rem",
  "code-4": "1.75rem",
  "code-5": "1.75rem",
  "code-6": "2.0rem",
  "code-7": "2.25rem",
  "code-8": "2.5rem",
  "code-9": "3.0rem"
}, g = {
  0: "0px",
  1: "0.125rem",
  2: "0.25rem",
  3: "0.375rem",
  4: "0.5rem",
  5: "0.75rem",
  6: "1rem",
  full: "9999px"
}, f = {
  0: "0px 0px 0px 0px rgba(0, 0, 0, 0.00)",
  inner: "0px 5px 2px 0px rgba(28, 32, 36, 0.01) inset, 0px 3px 2px 0px rgba(28, 32, 36, 0.03) inset, 0px 1px 1px 0px rgba(28, 32, 36, 0.05) inset, 0px 0px 1px 0px rgba(28, 32, 36, 0.06) inset",
  1: "0px 5px 2px 0px rgba(28, 32, 36, 0.01), 0px 3px 2px 0px rgba(28, 32, 36, 0.03), 0px 1px 1px 0px rgba(28, 32, 36, 0.05), 0px 0px 1px 0px rgba(28, 32, 36, 0.06)",
  2: "0px 16px 7px 0px rgba(28, 32, 36, 0.01), 0px 9px 6px 0px rgba(28, 32, 36, 0.03), 0px 4px 4px 0px rgba(28, 32, 36, 0.05), 0px 1px 2px 0px rgba(28, 32, 36, 0.06)",
  3: "0px 29px 12px 0px rgba(28, 32, 36, 0.01), 0px 16px 10px 0px rgba(28, 32, 36, 0.03), 0px 7px 7px 0px rgba(28, 32, 36, 0.05), 0px 2px 4px 0px rgba(28, 32, 36, 0.06)"
}, l = {
  px: "1px",
  0: "0px",
  1: "0.25rem",
  2: "0.5rem",
  3: "0.75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "2.75rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem",
  140: "35rem",
  160: "40rem",
  // Default card and modal width
  full: "100%",
  auto: "auto"
}, i = {
  0: "0.6875rem",
  1: "0.75rem",
  2: "0.875rem",
  3: "1rem",
  4: "1.125rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.875rem",
  8: "2.25rem",
  9: "3rem",
  "code-0": "0.625rem",
  "code-1": "0.688rem",
  "code-2": "0.812rem",
  "code-4": "1.062rem",
  "code-5": "1.188rem",
  "code-6": "1.438rem",
  "code-7": "1.75rem",
  "code-8": "2.125rem",
  "code-9": "2.875rem"
}, b = {
  0: "0.25%",
  1: "0.25%",
  2: "0",
  3: "0",
  4: "-0.25%",
  5: "-0.5%",
  6: "-0.625%",
  7: "-0.75%",
  8: "-1%",
  9: "-2.5%"
}, h = {
  regular: "400",
  medium: "500",
  "semi-bold": "600"
}, k = {
  hidden: "-1",
  base: "0",
  auto: "auto",
  dropdown: "1000",
  sticky: "1100",
  banner: "1200",
  overlay: "1300",
  modal: "1400",
  popover: "1500",
  skipLink: "1600",
  toast: "1700",
  tooltip: "1800"
}, c = {
  tokens: {
    "border-style": e,
    color: a,
    rounded: g,
    shadow: f,
    spacing: l,
    family: d,
    leading: t,
    tracking: b,
    text: i,
    weight: h,
    breakpoint: r,
    zIndex: k
  }
};
export {
  c as default
};
//# sourceMappingURL=index.mjs.map
